import clsx from 'clsx';
import React from 'react';
import { useFlexAssessmentContext } from '../context/context';
import { FlexAssessmentContextAction } from '../types/flex-assessment-context-action';
import { NotificationType } from '../types/notification-type';
import styles from './../css/notificationBar.module.scss';

const NotificationBar = React.memo((): JSX.Element | null => {
  const {
    state: { notifications },
    dispatch,
  } = useFlexAssessmentContext();

  return (
    <>
      {notifications.map((item) => {
        const { type, message, id } = item;
        return (
          <div
            key={id}
            className={clsx(styles.notificationBar, {
              [styles.error]: type === NotificationType.Error,
              [styles.success]: type === NotificationType.Success,
            })}
          >
            <span
              dangerouslySetInnerHTML={{
                __html: message as string,
              }}
            />
            <button
              onClick={() =>
                dispatch({
                  type: FlexAssessmentContextAction.dismissNotification,
                  payload: {
                    id,
                  },
                })
              }
              className={styles.dismissErrorButton}
              aria-label="Dismiss notification"
            />
          </div>
        );
      })}
    </>
  );
});

export default NotificationBar;
